import Head from "next/head";
import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getAdobeScriptGI, getAdobeScriptMMT } from "@mmt/event-logger";

interface LoadAdobeScriptProps {
  env?: "development" | "production";
  partner?: "mmt" | "gi";
}

const LoadAdobeScript: React.FC<LoadAdobeScriptProps> = ({
  partner = "mmt",
}) => {
  const env =
    process.env["NODE_ENV"] === "development" ? "development" : "production";
  return (
    <Head>
      <script
        src={partner === "mmt" ? getAdobeScriptMMT(env) : getAdobeScriptGI(env)}
        async
      />
    </Head>
  );
};

export default LoadAdobeScript;
